import React from 'react'
import ModalPortal from '@Components/Popups/ModalPortal'
import ConfirmationStep from '@Components/Navigations/CreateWorkBottomNavs/ConfirmSubmission/ConfirmationStep'
import OverclaimWarningStep from '@Components/Navigations/CreateWorkBottomNavs/ConfirmSubmission/OverclaimWarningStep'

interface ConfirmSubmissionProps {
    createWork(): void
    isSideBarOpen: boolean
    closeSidebar(): void
    isInternal: boolean
    disableButton?: boolean
    step?: 'overclaim' | 'submit'
    onClickConfirmOverclaim?: () => void
}

const ConfirmSubmission = (props: ConfirmSubmissionProps) => {
    const { isSideBarOpen, closeSidebar, step, onClickConfirmOverclaim } = props

    return (
        <ModalPortal isOpen={isSideBarOpen} onClose={closeSidebar}>
            {step === 'overclaim' ? (
                onClickConfirmOverclaim && (
                    <OverclaimWarningStep onClickConfirm={onClickConfirmOverclaim} onClickCancel={closeSidebar} />
                )
            ) : (
                <ConfirmationStep {...props} />
            )}
        </ModalPortal>
    )
}
export default ConfirmSubmission
